function parseTaxUUIDList(value) {
    if (value == null || value === '') {
        return [];
    }
    return String(value).split(',').filter(taxUUID => taxUUID !== '');
}

function remapActiveTaxUUIDList(value, invoiceTaxUUIDMap) {
    return parseTaxUUIDList(value)
        .filter(settingTaxUUID => invoiceTaxUUIDMap.has(settingTaxUUID))
        .map(settingTaxUUID => invoiceTaxUUIDMap.get(settingTaxUUID))
        .join(',');
}

export function createInvoiceTaxInfoList(settingTaxInfoList, createUUID) {
    const invoiceTaxInfoList = Array.isArray(settingTaxInfoList)
        ? JSON.parse(JSON.stringify(settingTaxInfoList)).filter(taxInfo =>
            taxInfo != null && taxInfo.innerUUID != null && taxInfo.innerUUID !== '')
        : [];
    const invoiceTaxUUIDMap = new Map();

    for (let i = 0; i < invoiceTaxInfoList.length; i++) {
        const taxInfo = invoiceTaxInfoList[i];
        const invoiceTaxUUID = createUUID();
        invoiceTaxUUIDMap.set(taxInfo.innerUUID, invoiceTaxUUID);
        taxInfo.settingTaxInfoUUID = taxInfo.innerUUID;
        taxInfo.newInnerUUID = invoiceTaxUUID;
        taxInfo.fromClient = 3;
        taxInfo.belongToSetting = 0;
    }

    for (let i = 0; i < invoiceTaxInfoList.length; i++) {
        const taxInfo = invoiceTaxInfoList[i];
        taxInfo.accumulateTaxInfoUUIDArrayKey = remapActiveTaxUUIDList(
            taxInfo.accumulateTaxInfoUUIDArrayKey,
            invoiceTaxUUIDMap
        );
        taxInfo.beAccumulateTaxInfoUUIDArrayKey = remapActiveTaxUUIDList(
            taxInfo.beAccumulateTaxInfoUUIDArrayKey,
            invoiceTaxUUIDMap
        );
    }

    return invoiceTaxInfoList;
}

export function buildTaxCalculationFactorMap(invoiceTaxInfoList, itemTaxInfoList) {
    invoiceTaxInfoList = Array.isArray(invoiceTaxInfoList) ? invoiceTaxInfoList : [];
    itemTaxInfoList = Array.isArray(itemTaxInfoList) ? itemTaxInfoList : [];

    const invoiceTaxInfoMap = new Map();
    for (let i = 0; i < invoiceTaxInfoList.length; i++) {
        const taxInfo = invoiceTaxInfoList[i];
        if (taxInfo == null || taxInfo.newInnerUUID == null || taxInfo.newInnerUUID === '') {
            continue;
        }
        invoiceTaxInfoMap.set(taxInfo.newInnerUUID, taxInfo);
    }

    const taxRateMap = new Map();
    invoiceTaxInfoMap.forEach((taxInfo, taxUUID) => {
        taxRateMap.set(taxUUID, 0);
    });
    for (let i = 0; i < itemTaxInfoList.length; i++) {
        const itemTaxInfo = itemTaxInfoList[i];
        if (itemTaxInfo == null || !invoiceTaxInfoMap.has(itemTaxInfo.newInnerUUID)) {
            continue;
        }
        if (itemTaxInfo.chooseRate === '-1' || itemTaxInfo.chooseRate === -1) {
            taxRateMap.set(itemTaxInfo.newInnerUUID, 0);
            continue;
        }
        const taxRate = Number(itemTaxInfo.chooseRate);
        if (!Number.isFinite(taxRate)) {
            continue;
        }
        taxRateMap.set(itemTaxInfo.newInnerUUID, taxRate);
    }

    const factorMap = new Map();
    const calculatingTaxUUIDSet = new Set();

    function calculateFactor(taxUUID) {
        if (factorMap.has(taxUUID)) {
            return factorMap.get(taxUUID);
        }
        if (calculatingTaxUUIDSet.has(taxUUID)) {
            return 0;
        }
        const taxInfo = invoiceTaxInfoMap.get(taxUUID);
        if (taxInfo === undefined) {
            return 0;
        }

        calculatingTaxUUIDSet.add(taxUUID);
        const taxInclusive = Number(taxInfo.taxInclusive) === 1;
        const dependencyUUIDList = parseTaxUUIDList(taxInfo.accumulateTaxInfoUUIDArrayKey);
        let dependencyFactor = 0;
        for (let i = 0; i < dependencyUUIDList.length; i++) {
            const dependencyTaxInfo = invoiceTaxInfoMap.get(dependencyUUIDList[i]);
            if (dependencyTaxInfo === undefined) {
                continue;
            }
            if (!taxInclusive || Number(dependencyTaxInfo.taxInclusive) === 1) {
                dependencyFactor += calculateFactor(dependencyUUIDList[i]);
            }
        }

        const taxFactor = taxRateMap.get(taxUUID) * (1 + dependencyFactor);
        calculatingTaxUUIDSet.delete(taxUUID);
        factorMap.set(taxUUID, taxFactor);
        return taxFactor;
    }

    invoiceTaxInfoMap.forEach((taxInfo, taxUUID) => {
        calculateFactor(taxUUID);
    });
    return factorMap;
}
